var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        show: _vm.show,
        "max-width": _vm.maxWidth,
        closeable: _vm.closeable,
      },
      on: { close: _vm.close },
    },
    [
      _c("div", { staticClass: "px-6 py-4" }, [
        _c("div", { staticClass: "text-lg" }, [_vm._t("title")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4" }, [_vm._t("content")], 2),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "px-6 py-4 bg-gray-100 text-right" },
        [_vm._t("footer")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }